import { explainEmptyPlan } from '../models/schedule';
import { isOpen, isPausedOn } from './task-scope';
import { dormantProjectIds } from './unscheduled';
/**
 * Why a day's plan came out empty — the one reading the Today screen and the
 * assistant's read_plan both give.
 *
 * Each built `explainEmptyPlan`'s inputs itself, and disagreed: the app read
 * the work hours off the plan (an overnight shift is judged by its own
 * window), the assistant off the settings with a 9–5 default; the assistant
 * counted paused tasks as still waiting, the app didn't; neither left out
 * work in a paused project, though the sentence says "or in a paused project";
 * and the assistant judged "today's hours have passed" on the server's UTC
 * clock.
 *
 * Null when the plan has tasks on it, or when there is no crisp reason.
 */
export function emptyPlanReason(schedule, tasks, projects, options) {
    if (!schedule)
        return null;
    if ((schedule.scheduled_tasks ?? []).some((st) => !st.is_buffer))
        return null;
    const dormant = dormantProjectIds(projects);
    return explainEmptyPlan({
        workStart: schedule.constraints?.work_start ?? '08:00',
        workEnd: schedule.constraints?.work_end ?? '22:00',
        isToday: options.date === options.today,
        eligibleTasks: tasks.filter((t) => !t.is_habit && isOpen(t)
            && !isPausedOn(t, options.today) && !dormant.has(t.project_id)).length,
        now: options.now,
    });
}
//# sourceMappingURL=empty-plan.js.map